import React, { useState, useRef, useEffect } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

export default function CustomSelectComp({
  ControllerProps,
  dispatchItemToredux,
  colorsArray,
  customColorModal,
  setSelectedColorPalette,
  isParent = false,
}) {
  const { title, reduxKey, options, defaultValue } = ControllerProps;
  // console.log(options);
  // console.log(isParent);
  // console.log(defaultValue);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    if (customColorModal) {
      // console.log(option);
      setSelectedColorPalette(option);
      setSelectedOption(option);
      setIsOpen(false);
    } else {
      setSelectedOption(option);
      dispatchItemToredux(option, reduxKey);
      setIsOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const mappedOption = customColorModal ? colorsArray : options;
  const defaultOption = customColorModal
    ? colorsArray[0].label
    : defaultValue.label;
  // console.log(customColorModal);

  return (
    <main
      className={`  ${
        customColorModal
          ? "items-center justify-left flex w-full p-0"
          : isParent
          ? "flex items-center justify-start w-full h-10 gap-2"
          : "flex flex-col items-start justify-start w-full h-[3.7rem] gap-2"
      }  `}
    >
      {customColorModal ? null : (
        <button className="font-light w-full h-auto text-left text-sm truncate">
          {title}
        </button>
      )}

      <div className=" relative flex w-full" ref={dropdownRef}>
        <div
          className={`font-light p-[2px] ${
            customColorModal ? "w-full" : isParent ? "w-[98.5%]" : "w-full"
          }  border rounded border-gray-200 cursor-pointer bg-white flex items-center justify-between text-sm`}
          onClick={toggleDropdown}
        >
          {selectedOption ? selectedOption.label : defaultOption}
          {isOpen ? (
            <MdKeyboardArrowUp className="text-2xl relative left-1" />
          ) : (
            <MdKeyboardArrowDown className="text-2xl relative left-1" />
          )}
        </div>
        {isOpen && (
          <div
            className={`overflow-y-auto absolute top-8 z-10 w-full bg-white border border-gray-300 shadow  rounded flex items-start justify-between flex-col mb-4 ${
              isParent ? "h-[5rem]" : "h-[12rem]"
            }`}
          >
            {Array.isArray(mappedOption) &&
              mappedOption.map((option, index) => (
                <div
                  key={index}
                  className="py-2 pl-2 w-full cursor-pointer hover:bg-gray-200 rounded flex gap-2 items-center justify-between px-2"
                  onClick={() => handleOptionClick(option)}
                >
                  <button className=" font-light truncate  text-sm">
                    {option.label}
                  </button>
                </div>
              ))}
          </div>
        )}
      </div>
    </main>
  );
}
